/** Topics are never deleted, because past assignments refer to them. `Deprecated` retires one. */
export enum TaxonomyStatus {
  Active = 'active',
  Deprecated = 'deprecated',
}
